/**
 * Lieferdatum-Vorschau: Logbase Slots API (90 Tage) oder einfache Mo–Fr-Fallback-Liste.
 */
(function () {
  var SLOTS_API = 'https://slots-app.logbase.io/api/slots';

  function isWeekend(d) {
    var day = d.getDay();
    return day === 0 || day === 6;
  }

  function nextWeekdayAfter(d) {
    var n = new Date(d);
    n.setDate(n.getDate() + 1);
    while (isWeekend(n)) {
      n.setDate(n.getDate() + 1);
    }
    return n;
  }

  function buildBusinessDaysFrom(start, count) {
    var out = [];
    var cur = new Date(start);
    cur.setHours(0, 0, 0, 0);
    if (isWeekend(cur)) {
      cur = nextWeekdayAfter(cur);
    }
    for (var i = 0; i < count; i++) {
      out.push(new Date(cur));
      cur = nextWeekdayAfter(cur);
    }
    return out;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function monthYearPairsFromRange(startDate, endDate) {
    var pairs = [];
    var cur = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    var endMarker = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
    while (cur <= endMarker) {
      pairs.push({ month: cur.getMonth(), year: cur.getFullYear() });
      cur.setMonth(cur.getMonth() + 1);
    }
    return pairs;
  }

  function localDateKey(d) {
    var y = d.getFullYear();
    var m = d.getMonth() + 1;
    var day = d.getDate();
    return (
      y +
      '-' +
      (m < 10 ? '0' : '') +
      m +
      '-' +
      (day < 10 ? '0' : '') +
      day
    );
  }

  function dateKeyFromSlot(slot) {
    var d = new Date(slot.date);
    if (isNaN(d.getTime())) return null;
    d.setHours(0, 0, 0, 0);
    return localDateKey(d);
  }

  function enumerateWeekdays(start, end) {
    var out = [];
    var d = new Date(start);
    d.setHours(0, 0, 0, 0);
    var endD = new Date(end);
    endD.setHours(0, 0, 0, 0);
    while (d <= endD) {
      if (!isWeekend(d)) {
        out.push(new Date(d));
      }
      d.setDate(d.getDate() + 1);
    }
    return out;
  }

  function fetchMergedSlots(shopDomain, locationId, fulfillmentType, horizonDays) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var end = new Date(today);
    end.setDate(end.getDate() + horizonDays);
    var pairs = monthYearPairsFromRange(today, end);

    return Promise.all(
      pairs.map(function (pair) {
        return fetch(SLOTS_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            myShopifyDomain: shopDomain,
            locationId: locationId,
            fulfillmentType: fulfillmentType,
            month: pair.month,
            year: pair.year,
          }),
        }).then(function (r) {
          if (!r.ok) throw new Error('slots_http_' + r.status);
          return r.json();
        });
      })
    ).then(function (responses) {
      var byKey = new Map();
      responses.forEach(function (res) {
        var slots = res.slots || [];
        slots.forEach(function (s) {
          var key = dateKeyFromSlot(s);
          if (!key) return;
          if (!byKey.has(key)) {
            byKey.set(key, s);
          } else {
            var existing = byKey.get(key);
            var a = (s.timeSlots && s.timeSlots.length) || 0;
            var b = (existing.timeSlots && existing.timeSlots.length) || 0;
            if (a > b) byKey.set(key, s);
          }
        });
      });
      return Array.from(byKey.values()).sort(function (a, b) {
        return new Date(a.date) - new Date(b.date);
      });
    });
  }

  function slotMapFromSlots(slots) {
    var m = new Map();
    slots.forEach(function (s) {
      var k = dateKeyFromSlot(s);
      if (!k) return;
      if (!m.has(k)) {
        m.set(k, s);
      } else {
        var ex = m.get(k);
        var a = (s.timeSlots && s.timeSlots.length) || 0;
        var b = (ex.timeSlots && ex.timeSlots.length) || 0;
        if (a > b) m.set(k, s);
      }
    });
    return m;
  }

  function statusFromSlot(slot) {
    var ts = (slot && slot.timeSlots) || [];
    if (ts.length === 0) return 'booked';
    if (ts.length === 1) return 'few';
    return 'available';
  }

  /**
   * Pro Werktag im Fenster [heute … heute+horizon]: kein API-Slot = ausgebucht;
   * 1 timeSlot = wenige; 2+ = verfügbar (ohne Zusatzzeile).
   */
  function buildApiCalendarItems(slotMap, horizonDays, maxCards) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var maxDate = new Date(today);
    maxDate.setDate(maxDate.getDate() + horizonDays);
    var weekdays = enumerateWeekdays(today, maxDate);
    var limited = weekdays.slice(0, Math.max(1, maxCards));
    return limited.map(function (date) {
      var key = localDateKey(date);
      var slot = slotMap.get(key);
      if (!slot) {
        return { dateObj: date, status: 'booked' };
      }
      return { dateObj: date, status: statusFromSlot(slot) };
    });
  }

  function renderCards(track, items, locale, labelBooked, labelFew) {
    var wdFmt = new Intl.DateTimeFormat(locale, { weekday: 'short' });
    var dmFmt = new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit' });

    track.textContent = '';
    items.forEach(function (item) {
      var date = item.dateObj;
      var status = item.status;

      var card = document.createElement('div');
      card.className = 'delivery-date-preview__card';
      card.setAttribute('data-status', status);
      card.setAttribute('role', 'listitem');

      var dateEl = document.createElement('div');
      dateEl.className = 'delivery-date-preview__date';
      var wd = wdFmt.format(date).replace(/\.$/, '').trim();
      var dm = dmFmt.format(date);
      dateEl.textContent = wd + ', ' + dm;
      card.appendChild(dateEl);

      if (status !== 'available') {
        var st = document.createElement('div');
        st.className = 'delivery-date-preview__status';
        st.textContent = status === 'booked' ? labelBooked : labelFew;
        card.appendChild(st);
      }

      track.appendChild(card);
    });
  }

  function attachCarouselControls(track, btnPrev, btnNext) {
    function scrollStep(dir) {
      var card = track.querySelector('.delivery-date-preview__card');
      var gap = parseFloat(getComputedStyle(track).gap) || 12;
      var step = card ? card.offsetWidth + gap : 140;
      var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
      track.scrollBy({ left: dir * step, behavior: behavior });
    }

    btnPrev.addEventListener('click', function () {
      scrollStep(-1);
    });
    btnNext.addEventListener('click', function () {
      scrollStep(1);
    });

    track.addEventListener(
      'wheel',
      function (e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          return;
        }
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 0) {
          return;
        }
        var delta = e.deltaY;
        if (delta > 0 && track.scrollLeft >= max - 0.5) {
          return;
        }
        if (delta < 0 && track.scrollLeft <= 0.5) {
          return;
        }
        track.scrollLeft = Math.max(0, Math.min(max, track.scrollLeft + delta));
        e.preventDefault();
      },
      { passive: false }
    );

    var dragActive = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') {
        return;
      }
      if (e.pointerType === 'mouse' && e.button !== 0) {
        return;
      }
      dragActive = true;
      dragStartX = e.clientX;
      dragStartScrollLeft = track.scrollLeft;
      track.classList.add('delivery-date-preview__track--dragging');
      try {
        track.setPointerCapture(e.pointerId);
      } catch (err) {}
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragActive) {
        return;
      }
      var dx = e.clientX - dragStartX;
      track.scrollLeft = dragStartScrollLeft - dx;
    });

    function endPointerDrag(e) {
      if (!dragActive) {
        return;
      }
      dragActive = false;
      track.classList.remove('delivery-date-preview__track--dragging');
      try {
        track.releasePointerCapture(e.pointerId);
      } catch (err) {}
    }

    track.addEventListener('pointerup', endPointerDrag);
    track.addEventListener('pointercancel', endPointerDrag);
  }

  function initRoot(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var count = parseInt(root.dataset.daysCount || '24', 10);
    var locale = root.dataset.locale || 'de';
    var labelBooked = root.dataset.labelBooked || '';
    var labelFew = root.dataset.labelFew || '';
    var shopDomain = root.dataset.shopDomain || '';
    var locationId = (root.dataset.locationId || '').trim();
    var fulfillmentType = root.dataset.fulfillmentType || 'delivery';
    var horizonDays = parseInt(root.dataset.horizonDays || '90', 10);
    var fallbackOnError = root.dataset.fallbackOnError === 'true';
    var errorText = root.dataset.errorText || '';

    var track = root.querySelector('[data-delivery-date-track]');
    var btnPrev = root.querySelector('[data-delivery-date-prev]');
    var btnNext = root.querySelector('[data-delivery-date-next]');
    var loadingEl = root.querySelector('[data-delivery-date-loading]');
    if (!track || !btnPrev || !btnNext) return;

    function buildFallbackItems() {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var dates = buildBusinessDaysFrom(today, Math.max(1, count));
      return dates.map(function (date) {
        return { dateObj: date, status: 'available' };
      });
    }

    function showErrorMessage() {
      track.textContent = '';
      var p = document.createElement('p');
      p.className = 'delivery-date-preview__error';
      p.textContent = errorText;
      track.appendChild(p);
    }

    function run() {
      var useApi = locationId && shopDomain;

      if (useApi) {
        if (loadingEl) loadingEl.hidden = false;
        fetchMergedSlots(shopDomain, locationId, fulfillmentType, horizonDays)
          .then(function (slots) {
            var map = slotMapFromSlots(slots);
            var items = buildApiCalendarItems(map, horizonDays, count);
            renderCards(track, items, locale, labelBooked, labelFew);
          })
          .catch(function () {
            if (fallbackOnError) {
              renderCards(track, buildFallbackItems(), locale, labelBooked, labelFew);
            } else {
              showErrorMessage();
            }
          })
          .finally(function () {
            if (loadingEl) loadingEl.hidden = true;
            attachCarouselControls(track, btnPrev, btnNext);
          });
      } else {
        if (loadingEl) loadingEl.hidden = true;
        renderCards(track, buildFallbackItems(), locale, labelBooked, labelFew);
        attachCarouselControls(track, btnPrev, btnNext);
      }
    }

    run();
  }

  function initAll() {
    document.querySelectorAll('[data-delivery-date-preview]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var scope = event.target || document;
    if (scope.matches && scope.matches('[data-delivery-date-preview]')) {
      initRoot(scope);
      return;
    }
    scope.querySelectorAll('[data-delivery-date-preview]').forEach(initRoot);
  });
})();
